import { Navigate, useParams } from "react-router-dom"

interface Props {
    to: string
}

export function RouterRedirect(props: Props) {
    const hasParams = props.to.includes(":")
    const params = useParams()
    if (hasParams && params) {
        const to = Object.keys(params).reduce((acc, key) => {
            return acc.replace(`:${key}`, params[key] || "")
        }, props.to)
        return <Navigate to={to} />

    }
    return <Navigate to={props.to} />
} 